"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlickgridEventAggregator = void 0;
/**
 * A class that will be used for internal communication of parent-child
 *
 * All methods are abstract for typings purposes only
 */
class SlickgridEventAggregator {
}
exports.SlickgridEventAggregator = SlickgridEventAggregator;
//# sourceMappingURL=slickgridEventAggregator.js.map